/** axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'

import QS from 'qs'
import Cookies from 'js-cookie'
import {
  mes
} from '@/conf/resetMessage'
import {
  Message
} from 'element-ui'
import store from '../../../store' //Vuex
import router from '../../../router'


const axiosData = axios.create()

export let Header = {
  client: '',
  v2Client: '',
  test: '',
  dm: ''
}
// 环境的切换
Header.v2Client = process.env.VUE_APP_XHAPP_Base_Url
if (process.env.NODE_ENV == 'development') {
  Header.client = 'DataCenter'
  Header.test = '/test'
  // Header.v2Client = '/v2Client'
  Header.cnfPdBase = '/kgapi'
  Header.cnfinance = '/cnfinance'
  Header.app = '/app'
  Header.cnfRecommend = '/recommend'
  // Header.pdBase = 'http://kgapi.plantdata.cn'
} else if (process.env.NODE_ENV == 'uat') {
  //生产环境下 配置  public/static/config.js可更改
  //  示例  三期生产环境下后台地址
  Header.client = window.OauthConfig.client
  // Header.v2Client = window.OauthConfig.v2Client
  Header.cnfPdBase = window.OauthConfig.pdBase +"/kgapi"
  Header.cnfRecommend = window.OauthConfig.pdBase +"/recommend"
  Header.cnfinance = window.OauthConfig.cnfinance
}else if (process.env.NODE_ENV == 'production') {
  //生产环境下 配置  public/static/config.js可更改
  //  示例  三期生产环境下后台地址
  Header.client = window.OauthConfig.client
  // Header.v2Client = window.OauthConfig.v2Client
  Header.cnfPdBase = window.OauthConfig.pdBase +"/kgapi"
  Header.cnfRecommend = window.OauthConfig.pdBase +"/recommend"
  Header.cnfinance = window.OauthConfig.cnfinance
}
export let programHeader = Header
const brandToken = 'brand-token'

// 请求超时时间
axiosData.defaults.timeout = 100000
// post请求头
axiosData.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// 设置携带Cookie信息
axiosData.defaults.withCredentials = true

// 请求拦截器
axiosData.interceptors.request.use(config => {
  // let v2Token = Cookies.get("v2Token") || "";
  // if (v2Token) {
  //   // config.headers.Authorization = localStorage.getItem('token');
  // config.headers["Accept-Token"] = "MyLcRCptsHoXTskIIvCqu4AzPtfvy5ts!&JaJi#mTL!7TCxEdu4qYQClU7GsS"
  // }
  return config
}, (error) => {
  return Promise.reject(error)
})

axiosData.interceptors.response.use(
  response => {
    if (response.data.code === 200) {
      if (
        response.data.brandToken &&
        response.data.brandToken !== 'undefined'
      ) {
        localStorage.setItem(brandToken, response.data.brandToken)
      }
      return Promise.resolve(response)
    } else if (response.data.code === 110001) {
      localStorage.removeItem(brandToken)
      mes.error({
        message: response.data.message
      })
      router.replace('/')
    } else if (response.data.code === 100001) {
      localStorage.removeItem(brandToken)
      // router.replace('/')
      if (process.env.NODE_ENV !== 'development') {
        let str = location.href
        let num = str.indexOf('#')
        str = str.substr(num + 1)
        console.log('2222');
        window.location.href = 'https://en.imsilkroad.com/login#' + str
      }
    } else if (response.data.code === 110002) {
      // mes.error({message: response.data.message})
    } else if (response.data.code === 110000) {
      localStorage.removeItem(brandToken)
      mes.error({
        message: response.data.message
      })
    } else if (response.data.code === 40000) {
      Message.warning({
        message: `Sorry No Permission!`,
        duration: 3000
      })
    } else if (response.data.code === 401) {
      //登出
      window.location.href = 'https://en.imsilkroad.com/quit'
    }
    return response
  },
  // 服务器状态码不是200的情况
  (error) => {
    console.error(error)
    // console.log(error.response.data, "error.response");
    if (error.response.data) {
      if (error.response.data.status === 500) {
        if (!response.data.code === 100001 || !response.data.code === 110001) {
          mes.error({
            message: error.response.data.message
          })
        }
      }
      if (
        error.response.data.error == 'invalid_grant' ||
        error.response.data.error == 'invalid_token'
      ) {
        //当code重复时 err:invalid_grant
        location.href = Header.login_url
      }
      if (
        error.response.data.error == 'access_denied' ||
        error.response.data.error == 'unauthorized'
      ) {
        Message.error({
          message: 'Sorry, insufficient permissions, please contact the administrator !',
          duration: 3000
        })
        return Promise.reject(error.response)
      }
    }
  }
)

//状态码
const SUCCESS_CODE = 200

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axiosData.defaults.headers["token"] = params.token?params.token:''
    axiosData
      .get(url, params,{
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        // console.log(res,'logo')
        // console.log(res,'RES')
        resolve(res.data)
      })
      .catch((err) => {
        Message.error({
          message: `Connection to server failed !`,
          duration: 3000
        })
      })
  })
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function getFile(url, params) {
  // object
  if (typeof params == 'object') {
    params['brandToken'] = localStorage.getItem('brand-token')
  }
  //  undefind
  else if (typeof params == 'undefined') {
    params = {
      brandToken: localStorage.getItem('brand-token')
    }
  }
  return new Promise((resolve, reject) => {
    axiosData
      .get(url, {
        params: params,
        responseType: 'arraybuffer'
      })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function getImg(url, params) {
  return new Promise((resolve, reject) => {
    axiosData
      .get(url, {
        params: params,
        responseType: 'arraybuffer'
      })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]。
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params, Content = 'application/json') {
  return new Promise((resolve, reject) => {
    axiosData
      .post(url, params, {
        headers: {
          'Content-Type': Content,
        }
      })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        // Message.error({
        //   message: `连接服务器失败,请刷新后重试!`,
        //   duration: 3000
        // });
        reject(err)
      })
      .finally(() => {
        setTimeout(() => {
          // store.commit('changeLoadingstate', false);
        }, 500)
      })
  })
}


export function postToken(url, params) {
  if (typeof params == 'object') {
    params['brandToken'] = localStorage.getItem('brand-token')
  }
  return new Promise((resolve, reject) => {
    axiosData
      .post(url, params, {
        headers: {
          // Accept: "application/json",
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
      .finally(() => {
        setTimeout(() => {
          // store.commit('changeLoadingstate', false);
        }, 500)
      })
  })
}

export function postFormData(url, params) {
  return new Promise((resolve, reject) => {
    axiosData
      .post(url, params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function del(url, params) {
  if (!params) {
    params = {}
  }
  params.brandToken = localStorage.getItem('brand-token')
  return new Promise((resolve, reject) => {
    axiosData
      .delete(url, {
        params: params
      })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        // Message.error({
        //   message: `连接服务器失败,请刷新后重试!`,
        //   duration: 3000
        // });

        reject(err)
      })
      .finally(() => {
        setTimeout(() => {
          // store.commit('changeLoadingstate', false);
        }, 500)
      })
  })
}

/**
 * [put description] 请求方式
 *
 * @param   {[type]}  url     [url description]
 * @param   {[type]}  params  [params description]
 */
export function put(url, params) {
  // object
  if (typeof params == 'object') {
    params['brandToken'] = localStorage.getItem('brand-token')
  }
  //  undefind
  else if (typeof params == 'undefined') {
    params = {
      brandToken: localStorage.getItem('brand-token')
    }
  }
  return new Promise((resolve, reject) => {
    axiosData
      .put(url, params, {
        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*'
        }
      })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        // Message.error({
        //   message: `连接服务器失败,请刷新后重试!`,
        //   duration: 3000
        // });
        reject(err)
      })
      .finally(() => {
        setTimeout(() => {
          // store.commit('changeLoadingstate', false);
        }, 500)
      })
  })
}
export function getToken() {
  return new Promise((resolve, reject) => {
    let url = Header.cnfinance+'/cnfinance/generate/token/' + parseInt(Cookies.get("imsilkroad_userid"))
    axiosData
      .get(url, {
        headers: {
          'Accept-Token': null
        }
      })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        // Message.error({
        //   message: `Connection to server failed !`,
        //   duration: 3000
        // })
        reject(err)
      })
  })
}

// v2
export function getV2(url, params) {
  // object
  if (typeof params == 'object') {
    params['accessToken'] = Cookies.get('v2Token') || ''
  }
  //  undefind
  else if (typeof params == 'undefined') {
    params = {
      accessToken: Cookies.get('v2Token') || ''
    }
  }
  return new Promise((resolve, reject) => {
    axiosData
      .get(url, {
        params: params
      })
      .then((res) => {
        if (res == undefined || res.data.code == 100 || res.data.code == '100' || res.data.code == '101' || res.data.code == 101) {
         getToken().then((token) => {
            // axiosData.defaults.headers["Accept-Token"] = token
            axiosData
              .get(url, {
                params: params, 
                headers: {
                  'Accept-Token': token
                }
              })
              .then((res) => {
                resolve(res.data)
              })
              .catch((err) => {
                // Message.error({
                //   message: `Connection to server failed !`,
                //   duration: 3000
                // })
                reject(err)
              })
          })
        } else {
          resolve(res.data)
        }
      })
      .catch((err) => {
        reject(err)
      })
    // getToken().then((token) => {
    //   axiosData.defaults.headers["Accept-Token"] = token
    //   axiosData
    //     .get(url, {
    //       params: params
    //     })
    //     .then((res) => {
    //       resolve(res.data)
    //     })
    //     .catch((err) => {
    //       // Message.error({
    //       //   message: `Connection to server failed !`,
    //       //   duration: 3000
    //       // })
    //       reject(err)
    //     })
    // })
  })
}
// v2
export function getV3(url, params) {
  if (typeof params == 'object') {
    params['accessToken'] = Cookies.get('v2Token') || ''
  }
  //  undefind
  else if (typeof params == 'undefined') {
    params = {
      accessToken:  Cookies.get('v2Token') || ''
    }
  }
  return new Promise((resolve, reject) => {
    axiosData
      .get(url, {
        params: params
      })
      .then((res) => {
        if (res == undefined) {
          getToken().then((token) => {
            // axiosData.defaults.headers["Accept-Token"] = token
            axiosData
              .get(url, {
                params: params,
                headers: {
                  'Accept-Token': token
                }
              })
              .then((res) => {
                resolve(res.data)
              })
              .catch((err) => {
                // Message.error({
                //   message: `Connection to server failed !`,
                //   duration: 3000
                // })
                reject(err)
              })
          })
        } else {
          if (res.data.code == 100 || res.data.code == '100' || res.data.code == '101' || res.data.code == 101) {
            getToken().then((token) => {
              // axiosData.defaults.headers["Accept-Token"] = token
              axiosData
                .get(url, {
                  params: params,
                  headers: {
                    'Accept-Token': token
                  }
                })
                .then((res) => {
                  resolve(res.data)
                })
                .catch((err) => {
                  // Message.error({
                  //   message: `Connection to server failed !`,
                  //   duration: 3000
                  // })
                  reject(err)
                })
            })
          } else {
            resolve(res.data)
          }
        }
      })
      .catch((err) => {
        reject(err)
      })

    // getToken().then((token) => {
    //   axiosData.defaults.headers["Accept-Token"] = token
    //   axiosData
    //     .get(url, {
    //       params: params
    //     })
    //     .then((res) => {
    //       resolve(res.data)
    //     })
    //     .catch((err) => {
    //       reject(err)
    //     })
    // }).catch((err) => {
    //   reject(err)
    // })
  })
}

export function postV2(url, params, Content = 'application/json') {
  if (typeof params == 'object') {
    params['accessToken'] = Cookies.get('v2Token') || ''
  }
  //  undefind
  else if (typeof params == 'undefined') {
    params = {
      accessToken: Cookies.get('v2Token') || ''
    }
  }
  return new Promise((resolve, reject) => {
    axiosData
      .post(url, params, {
        headers: {
          'Content-Type': Content
          // 'Accept': '*/*'
        }
      })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        Message.error({
          message: `Connection to server failed !`,
          duration: 3000
        })
        reject(err)
      })
  })
}

export function delV2(url, params) {
  if (typeof params == 'object') {
    params['accessToken'] = Cookies.get('v2Token') || ''
  }
  //  undefind
  else if (typeof params == 'undefined') {
    params = {
      accessToken: Cookies.get('v2Token') || ''
    }
  }
  return new Promise((resolve, reject) => {
    axiosData
      .delete(url, {
        params: params
      })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        Message.error({
          message: `Connection to server failed !`,
          duration: 3000
        })
        reject(err)
      })
  })
}

// v2
export function getV2Patent(url, params) {
  return new Promise((resolve, reject) => {
    axiosData
      .get(url, {
        params: params
      })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        Message.error({
          message: `Connection to server failed !`,
          duration: 3000
        })
        reject(err)
      })
  })
}